import { useSearchParams } from 'react-router-dom';
import { urlLogin } from '../api/client';

/** A donde vuelve el back si el login falla, y lo que ve quien no tiene ningún rol de dwh. */
export function SinAccesoPage({ alSalir }: { alSalir?: () => void }) {
  const [q] = useSearchParams();
  const motivo = q.get('motivo');
  return (
    <div className="sin-acceso">
      <span className="logotipo logotipo-rojo">FONESTAR</span>
      <h1>dwh · réplica de X3</h1>
      {motivo ? (
        <p>No se ha podido completar el inicio de sesión ({motivo === 'rechazado' ? 'el proveedor de identidad lo ha rechazado' : 'la respuesta no era válida'}).</p>
      ) : (
        <p>
          Tu cuenta no tiene ningún rol en el proyecto <code>dwh</code> de auth.fonestar.com. Pídeselo a IT (dwh.lector para consultar,
          dwh.editor para cambiar la configuración).
        </p>
      )}
      <div className="acciones">
        <a className="boton boton-primario" href={urlLogin('/tablas')}>
          Volver a entrar
        </a>
        {alSalir && (
          <button type="button" className="boton boton-claro" onClick={alSalir}>
            Salir
          </button>
        )}
      </div>
    </div>
  );
}
